import { render, staticRenderFns } from "./TransferFieldValue.vue?vue&type=template&id=a84b50ec"
import script from "./TransferFieldValue.vue?vue&type=script&lang=js"
export * from "./TransferFieldValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports